import { render, staticRenderFns } from "./ResetPasswordMoodle.vue?vue&type=template&id=b38b19e6"
import script from "./ResetPasswordMoodle.vue?vue&type=script&lang=js"
export * from "./ResetPasswordMoodle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports